<template>
    <div v-if="detailParam && detailParam.title">
        <section class="main-slider">
            <div class="page-header-bg"  :style="{backgroundImage: detailParam.banner}">
            </div>
            <div class="container">
                <div class="page-header__inner" >
                    <div :class="detailParam.right ? 'phi_right' : ''">
                        <h1>
                            <!-- {{ detailParam.title }} -->
                            {{ $t(`solution.${detailParam.i18n_title}`) }}
                        </h1>
                    </div>
                    <div :class="detailParam.right ? 'phi_right' : ''">
                        <div  class="phi_content">
                            <div class="page-header__inner_text">
                                <!-- {{ detailParam.text }} -->
                                {{ $t(`solution.${detailParam.i18n_text}`) }}
                            </div>
                            <div class="page-header__inner_action">
                                <div class="page-header__inner_action_item action_item_margin  action_item-color button_hover" v-if="detailParam.url">
                                    <a>
                                        <!-- 产品演示 -->
                                        {{ $t('solution.solution_detail_demo') }}
                                    </a>
                                </div>
                                <div class="page-header__inner_action_item action_item_margin button_hover" @click="handleSeek()">
                                    <a>
                                        <!-- 联系我们 -->
                                         {{ $t('solution.solution_detail_contact') }}
                                    </a>
                                </div>
                            
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
	    <!-- 横向导航 -->
        <div id="nav-wrapper" class="nav-wrapper">
            <!--横向导航栏-->
            <ul>
                <li><a data-tab="#plan_overview"  class="active"> 
                    <!-- 方案概况  -->
                    {{ $t('solution.solution_nav_overview') }}
                </a></li>
                <li><a data-tab="#plan_build" > 
                    <!-- 方案架构  -->
                     {{ $t('solution.solution_nav_architecture') }}
                </a></li>
                <li><a data-tab="#plan_solve" > 
                    <!-- 解决方案场景  -->
                    {{ $t('solution.solution_nav_scene') }}
                </a></li>
                <li><a data-tab="#plan_custom" v-if="detailParam.i18n_customList.length"> 
                    <!-- 客户案例  -->
                    {{ $t('solution.solution_nav_custom') }}
                </a></li>
            </ul>
            <div class="clearfix"></div>
        </div>
        <!-- 方案概况 -->
        <section id="plan_overview" class="we-help" style="padding: 80px 0;background-color: #f9fafc;">
            <div class="container">
                
                <h2 class="container_title" >
                    <!-- 方案概况 -->
                    {{ $t('solution.solution_overview_title') }}
                </h2>
                <div class="row">
                    <div class="col-xl-12 col-lg-12 text_margin" style="    text-indent: 32px;">
                       <p> 
                        <!-- {{ detailParam.summarize }}  -->
                        {{ $t(`solution.${detailParam.i18n_summarize}`) }}
                       </p>
                    </div>
                   
                </div>
            </div>
        </section>
        <!-- 方案架构 -->
        <section id="plan_build" style="padding: 80px 0;background-color: #ffffff;">
            <div class="container">
                <h2 class="container_title"  >
                    <!-- 方案架构 -->
                      {{ $t('solution.solution_architecture_title') }}
                </h2>
                <div class="row">
                    <div class="col-xl-12 col-lg-12 text_margin " >
                        <img class="row_img" :src="detailParam.architecture" />
                    </div>
                </div>
            </div>

        </section>
        <!-- 解决方案 -->
        <section id="plan_solve" style="padding: 80px 0;background-color: #f9fafc;">
            <div class="container" style="background-color: #f9fafc; max-width: 1400px;">
                <h2 class="container_title" >
                    <!-- 解决方案场景 -->
                     {{ $t('solution.solution_scene_title') }}
                </h2>
                <div class="row text_margin margin_bottom">
                    <div class="col-xl-12 col-lg-12 text_margin scene_nav" >
                        <a v-for="(item, index) in detailParam.i18n_sceneList" 
                            :key="index" 
                            class="scene_nav_item" 
                            :class="item.type == sceneType ? 'scene_nav_act' : ''"
                            @click="handkeSwitch(item)"
                        >
                            <p> 
                                <!-- {{ item.title }}  -->
                                {{ $t(`solution.${item.title}`) }}
                            </p>
                        </a>
                    </div>
                </div>
                <div  v-for="(item, index) in detailParam.i18n_sceneList" :key="index"  >
                    <div class="row text_margin"  v-if="item.type == sceneType">
                        <div class="col-xl-6 col-lg-12 wow fadeInUp" >
                            <img  class="row_img" style="border-radius: 6px;" :src="item.sceneImg" />
                        </div>
                        <div class="col-xl-6 col-lg-12 wow fadeInUp " >
                            <h3 class="scene_title">
                                <!-- {{ item.introduceTitle }} -->
                                {{ $t(`solution.${item.introduceTitle}`) }}
                            </h3>
                            <div class="scene_text text_margin_buttom">
                            <p  v-for="(tdItem,tdIndex) in item.introduceList" :key="tdIndex">
                                <!-- {{ tdItem }} -->
                                {{ $t(`solution.${tdItem}`) }}
                            </p>
                            </div>
                            <h3 class="scene_title">
                                <!-- {{ item.meritTltle }} -->
                                {{ $t(`solution.${item.meritTltle}`) }}
                            </h3>
                            <div style="display: flex; margin-bottom: 15px;" v-for="(tdItem,tdIndex) in item.meritList" :key="tdIndex">
                                <div class="icon" style="color: var(--notech-base);font-size: var(--font-size-16); line-height: 1.5;">
										<span class="icon-check"></span>
									</div>
									<div class="text" style="margin-left: 10px; color: var(--notech-black); line-height: 1.5;">
										<p>
                                            <!-- {{ tdItem }} -->
                                             {{ $t(`solution.${tdItem}`) }}
                                        </p>
									</div>
                            </div>
                            <div class="scene_img" v-if="item.meritImg">
                                <img  :src="item.meritImg" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- 客户案例 -->
        <section id="plan_custom" class="contact-details" v-if="detailParam.i18n_customList.length">
            <div class="container">
                <h2 class="container_title">
                    <!-- 客户案例 -->
                     {{ $t('solution.solution_custom_title') }}
                </h2>
                <div class="row text_margin">
                    <div class="col-xl-3 col-lg-12 wow fadeInUp custom_item" v-for="(item,index) in detailParam.i18n_customList" :key="index" @click="handleRouter(item,index)" :data-wow-delay="(index+1)+'ms'" >
                        <img class="row_img" :src="item.img"  alt="">
                    </div> 
                </div>       
            </div>
        </section>
        <seek-dialog v-if="seekShow" :title="detailParam.title"  @close="handleClose"/>
    </div>
</template>

<script >
import SeekDialog from "@/components/seekDialog"
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'deatil',
     mixins: [MixinsList],
    components: {
        SeekDialog
    },
    data () {
        return {
            routeList: [],  // 面包屑
            detailParam: null,
            sceneType: "",
            seekShow: false,
        }
    },
    created() {
        this.getList()  // 获取内容
    },
    mounted () {
         // 确定选中的菜单
        $('.current').removeClass('current');  
        $('.solution_li').addClass('current');

        // $('.nav-wrapper a').click(function() {
		// 	// $('.nav-wrapper a').removeClass('active');
        //     $('.active').removeClass('active');
		// 	$(this).addClass('active');
		// 	$("html, body").animate({
		// 		// scrollTop: $($(this).attr("href")).offset().top - 62 + "px"
        //         scrollTop: $($(this).attr("data-tab")).offset().top - 55 + "px"
		// 	}, 1);
		// });

		// var navTop = $('.nav-wrapper').offset().top;
		// $(window).scroll(function() {
		// 	if ($(window).scrollTop() > navTop) {
		// 		$('.nav-wrapper').addClass('nav-wrapper_fixed');
		// 		$('.main-header').css("position", "relative");
		// 	} else {
		// 		$('.nav-wrapper').removeClass('nav-wrapper_fixed');
		// 		$('.main-header').css("position", "fixed");
		// 	}
		// });
    },
    beforeDestroy() {
        $(window).unbind('scroll')
    },
    methods: {
        // 初始化横向导航的 jQuery 逻辑
        initNavWrapper() {
            const $nav = $('.nav-wrapper');
            if (!$nav.length) return;
            $nav.find('a').on('click', function() {
                $('.active').removeClass('active');
                $(this).addClass('active');
                const target = $($(this).attr('data-tab'));
                if (target.length) {
                    $("html, body").animate({
                        scrollTop: target.offset().top - 55 + "px"
                    }, 1);
                }
            });
            const navTop = $nav.offset().top;
            $(window).scroll(function() {
                if ($(window).scrollTop() > navTop) {
                    $nav.addClass('nav-wrapper_fixed');
                    $('.main-header').css("position", "relative");
                } else {
                    $nav.removeClass('nav-wrapper_fixed');
                    $('.main-header').css("position", "fixed");
                }
            });
        },
        // 获取内容
        async getList() {
            // const { result } = res
            
            // // this.detailParam = JSON.parse(JSON.stringify(result.programmeList.pressureVessel))  
            // this.detailParam = result.programmeList[this.$route.query.type]
            // this.sceneType = this.detailParam.i18n_sceneList[0].type

            //   if(this.$i18n.locale == 'zh_CN') {
            //     this.detailParam.i18n_architecture = this.detailParam.architecture  // 客户案例图片
            // } else if(this.$i18n.locale == 'en_US') {
            //    this.detailParam.i18n_architecture = this.detailParam.architecture_en  // 客户案例图片
            // }else if(this.$i18n.locale == 'ru_RU') {

            // }

            try {
                    const  result = await loadData('solutionDetail', this.lang)

                    this.detailParam = result.programmeList[this.$route.query.type]
                    this.sceneType = this.detailParam.i18n_sceneList[0].type
            } catch (error) {
                console.log(error)
                this.detailParam= {}
            }

             // 数据就绪后初始化导航（v-if 变为 true，DOM 已渲染）
            this.$nextTick(() => {
                this.initNavWrapper();
            });

        },
        // 应用场景切换
        handkeSwitch(item) {
            this.sceneType = item.type
        },
        // 路由跳转
        handleRouter(val) {
            this.$router.push({
                path: val
            });
        },
          // 联系我们 
          handleSeek() {
            this.seekShow = true
        },
        // 关闭
        handleClose() {
            this.seekShow = false
        }
    }
}
</script>
<style scoped>
 @import '../../../public/static/css/aotai.css';
.page-header-bg {
    background-color: transparent;  
}
.phi_right {
    display:flex;
    justify-content:flex-end;
}
.page-header__inner h1{
    font-size: var(--font-size-45);
    /* width: 100%; */
    /* text-align: justify; */
    /* text-align-last: justify; */
    /* text-justify: distribute-all-lines;  兼容ie */
 }
  .phi_content {
    width: 50%;
 }
 .phi_right h1{
    width: 50%;
 }
.page-header__inner_text{
    width: 100%;
    font-size: var(--font-size-20);
    margin-top: 13px;
    line-height: 1.75;
    color: var(--notech-white);
 }
 .page-header__inner_action {
    width: 100%;
    margin-top: 50px;
    display: flex;
 }
 .page-header__inner_action_item {
    cursor: pointer;
    text-align: center;
    color: var(--notech-white);
    border-radius: 5px;
    width: 200px;    
   
    border: 1px solid rgba(169, 183, 222, 0.86);
    padding: 10px 15px;
    background: rgba(255, 255, 255, 0.2);
    position: relative;
    transition: all 0.36s;
    
 }
 .action_item_margin {
    margin: 0 18px;
 }
 .action_item-color {
    /* background: var(--notech-base); */
    background: #3595f7;
 }
 .button_hover:hover {
    /* background: #097cf2 !important; */
    background: var(--notech-base);
}
.row_img {
    max-width: 100%;
}

.scene_img {
    width: 100%;
    height: 240px;
}
.scene_img img {
    max-width: 100%;
    max-height: 100%;
}
/* 面包屑 */
/* ::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--notech-white) ;
}
::v-deep .el-breadcrumb__inner {
    color: var(--notech-white);
    font-size: var(--font-size-16);
    font-weight: 700;
    transition: all 500ms ease;
} */
.carousel__item {
    width: 100%;
    text-align: center;

}
.carousel__item_img {
    max-width: 100%;
    height: 100%;
}

 .nav-wrapper li a {
    font-size: var(--font-size-20);
    display: block;
    color: var(--notech-black);
    text-align: center;
    line-height: 78px;
    height: 78px;
    text-decoration: none;
}
.nav-wrapper li a:hover {
    color: #097cf2;
    border-bottom: solid 2px #097cf2;
}






.container_title {
    width: 100%;
    text-align: center;
    /* height: 80px; */
    line-height: 60px;
    font-size: var(--font-size-45);
    color: #232e5e;
}
.text_margin {
    margin-top: 20px;
    color: #666666;
    font-size: var(--font-size-16)
}

.sceneImg_item {
    display: none;
    transition: opacity 500ms ease 0s;
}
.sceneImg_show{
    display: block;
    transition: opacity 500ms ease 0s;
}
.scene_nav{
    width: 100%;
    height: 80px;
    line-height: 80px;
    display: flex;
    justify-content: center;
    border-bottom: 1px solid rgba(0,0,0,.1);
}
.scene_nav_item {
    cursor: pointer;
    width: 33%;
    text-align: center;
    font-weight: 400;
    font-size: var(--font-size-24);
    color: #4e5969;
}
.scene_nav_item:hover p{
    width: 60%;
    margin: 0 auto;
    background: var(--notech-base);
    color: #ffffff;
    transition: all 0.36s;
    border-radius: 6px;
}
.scene_nav_act p{
    width: 60%;
    margin: 0 auto;
    background: var(--notech-base);
    color: #ffffff;
    transition: all 0.36s;
    border-radius: 6px;
}
.scene_title {
    font-size: var(--font-size-24);
    font-weight: bold;
    margin-bottom: 20px;
}
.scene_text {
    
    font-size: var(--font-size-16);
    line-height: 30px;
}
.text_margin_buttom {
    margin-bottom: 50px;
}

.custom_item {
    cursor: pointer;    
    padding: 10px;
    text-align: center;
    box-shadow: 0px 5px 52px 0 rgba(19, 55, 159, 0.08)
}
.margin_bottom {
    margin-bottom: 60px;
}
</style> 
